import React from 'react';
import { Card, Stack, Group, Text, Button, ThemeIcon, Box } from '@mantine/core';
import { IconCheck, IconCalendarWeek } from '@tabler/icons-react';

interface UpcomingMealPlanCardProps {
  onViewHistory: () => void;
}

export const UpcomingMealPlanCard: React.FC<UpcomingMealPlanCardProps> = ({
  onViewHistory
}) => {
  return (
    <Card 
      radius="lg"
      style={{ 
        background: 'linear-gradient(135deg, #e8f5e8 0%, #f0f9f0 100%)',
        border: '1px solid var(--mantine-color-green-2)',
      }}
      p="lg"
    >
      {/* Mobile layout - stacked */}
      <Box hiddenFrom="sm">
        <Stack gap="md">
          <Group gap="md" align="center" wrap="nowrap">
            <ThemeIcon size={40} radius="md" variant="light" color="green" style={{ flexShrink: 0 }}>
              <IconCheck size={20} />
            </ThemeIcon>
            <Stack gap={4} style={{ flex: 1, minWidth: 0 }}>
              <Text fw={600} size="md" c="dark">
                You're all set for the week!
              </Text>
              <Text size="sm" c="dimmed">
                Your upcoming meal plans are ready to go
              </Text>
            </Stack>
          </Group>
          
          <Button 
            variant="subtle" 
            size="sm"
            leftSection={<IconCalendarWeek size={16} />}
            onClick={onViewHistory}
            fullWidth
          >
            View Plans
          </Button>
        </Stack>
      </Box>

      {/* Desktop layout - horizontal */}
      <Box visibleFrom="sm">
        <Group justify="space-between" align="center">
          <Group gap="md" align="center">
            <ThemeIcon size={40} radius="md" variant="light" color="green">
              <IconCheck size={20} />
            </ThemeIcon>
            <Stack gap={4}>
              <Text fw={600} size="md" c="dark">
                You're all set for the week!
              </Text>
              <Text size="sm" c="dimmed">
                Your upcoming meal plans are ready to go
              </Text>
            </Stack>
          </Group>
          
          <Button 
            variant="subtle" 
            size="sm"
            leftSection={<IconCalendarWeek size={16} />}
            onClick={onViewHistory}
          >
            View Plans
          </Button>
        </Group>
      </Box>
    </Card>
  );
};